import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiCpu, FiUsers, FiLayers, FiBarChart, FiAward } = FiIcons;

const WhyChooseUs = () => {
  const reasons = [
    { icon: FiCpu, text: "AI-powered targeting & automation" },
    { icon: FiUsers, text: "Creative copy, design & video team" },
    { icon: FiLayers, text: "Multi-channel integrated strategies" },
    { icon: FiBarChart, text: "Transparent reporting & analytics" },
    { icon: FiAward, text: "Proven results across industries" }
  ];

  // Container variants for staggered animations
  const containerVariants = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  // Item variants
  const itemVariants = {
    hidden: { x: -50, opacity: 0 },
    visible: { 
      x: 0, 
      opacity: 1,
      transition: {
        type: "spring",
        stiffness: 100
      }
    }
  };

  return (
    <section className="py-24 relative" style={{ backgroundColor: 'rgba(30, 15, 33, 0.7)' }}>
      {/* Using transparent background to show the global animated background */}
      <div className="max-w-6xl mx-auto px-6 relative z-10">
        <motion.div
          initial={{ y: 30, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <motion.h2 
            className="text-4xl md:text-5xl font-bold mb-6 text-purple-100"
            animate={{
              textShadow: [
                "0 0 0px rgba(255, 215, 0, 0)",
                "0 0 10px rgba(255, 215, 0, 0.3)",
                "0 0 0px rgba(255, 215, 0, 0)"
              ]
            }}
            transition={{
              duration: 2.5,
              repeat: Infinity
            }}
          >
            Why Choose <span className="text-yellow-400">advertisingpandit.com</span>
          </motion.h2>
        </motion.div>

        <motion.div 
          className="space-y-8"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          {reasons.map((reason, index) => (
            <motion.div
              key={index}
              variants={itemVariants}
              whileHover={{ 
                x: 10, 
                boxShadow: '0 0 30px rgba(177, 107, 189, 0.2)'
              }}
              className="flex items-center space-x-6 p-6 bg-purple-900 bg-opacity-20 rounded-2xl backdrop-blur-sm hover:bg-opacity-30 transition-all duration-300 border border-purple-800 hover:border-yellow-400"
            >
              <motion.div 
                className="p-4 rounded-full flex-shrink-0" 
                style={{ backgroundColor: '#FFD700' }}
                animate={{
                  boxShadow: [
                    "0 0 0px rgba(255, 215, 0, 0)",
                    "0 0 15px rgba(255, 215, 0, 0.7)",
                    "0 0 0px rgba(255, 215, 0, 0)"
                  ]
                }}
                transition={{
                  duration: 2,
                  delay: index * 0.3,
                  repeat: Infinity
                }}
              >
                <SafeIcon 
                  icon={reason.icon} 
                  className="text-2xl" 
                  style={{ color: '#3a1c40' }} 
                />
              </motion.div>
              <motion.span 
                className="text-xl font-semibold text-purple-100"
                whileHover={{ color: '#FFD700' }}
              >
                {reason.text}
              </motion.span>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default WhyChooseUs;